import React, { useEffect, useRef, useState } from 'react';
import { Box, Grid } from '@mui/material';
import Typography from '@mui/material/Typography';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import getRequest, { putRequest } from '../../../assets/helper/ApiHandler';
import { useNavigate } from 'react-router-dom';
import { Toast } from 'primereact/toast';
import { Dropdown } from 'primereact/dropdown';
import { MultiSelect } from 'primereact/multiselect';
import { regexPatterns } from '../../../assets/helper/RegexPattern';
import { Password } from 'primereact/password';
import { Divider } from 'primereact/divider';

var profileObject = {
    id: '',
    login: '',
    firstName: '',
    lastName: '',
    email: '',
    imageUrl: '',
    activated: false,
    langKey: '',
    createdBy: '',
    createdDate: null,
    lastModifiedBy: '',
    lastModifiedDate: null,
    authorities: '',
    password: ''

}
var formTouchedObj = {
    password: false
}

export default function Profile() {
    const toast = useRef(null);
    const [user, setUser] = useState(profileObject);
    const [passwordValue, setPasswordValue] = useState('');
    const [profileFormError, setProfileFormError] = useState(profileObject)
    const [formTouched, setFormTouched] = useState(formTouchedObj);

    useEffect(() => {
        getUsers();
    }, []);


    useEffect(() => {
        validateForm();
    }, [passwordValue]);


    const getUsers = async () => {
        try {
            const users = await getRequest(`/account`);
            setUser(users)
        } catch (error) {
            if(toast.current){
                toast.current.show({ severity: "error", summary: 'Error', detail: error });
            }
        }
    };

    const handleFormSubmit = async () => {
        if (validateForm(passwordValue)) {
            try {
                let res = await putRequest(`/account`, user);
                    if(toast.current){
                        toast.current.show({ severity: "success", summary: 'Success', detail: "Profile updated!" });
                    }
            } catch (error) {
                if(toast.current){
                    toast.current.show({ severity: "error", summary: 'Error', detail: error });
                }
            }
        } else {
            if(toast.current){
                toast.current.show({ severity: "error", summary: 'Error', detail: "Please fix the errors in the form" });
            }
        }
    };
    const handleInputChange = (e) => {
        const { id, value } = e.target;
        setUser((prevUser) => ({
            ...prevUser,
            [id]: value
        }));
        setFormTouched((prevFormTouched) => ({
            ...prevFormTouched,
            [id]: true,
        }))
    };

    const handleRoleChange = (e) => {
        setUser((prevUser) => ({
            ...prevUser,
            authorities: e.value || []
        }));
    };

    const userRoleName = (user) => {
        const roles = user.authorities || [];
        const roleName = roles.map(role => {
            if (role.startsWith('ROLE_INTERMEDIARY_')) {
                return role.replace('ROLE_INTERMEDIARY_', '');
            } else if (role.startsWith('ROLE_')) {
                return role.replace('ROLE_', '');
            }
            return role;
        }).join(', ');
        return roleName;
    }

    // const validateForm = () => {
    //     let errors = {};
    //     // if (user.password && !regexPatterns.password.test(user.password)) {
    //     // errors.password = 'Invalid password: must be at least 8 characters long and include at least one letter, one number, and one special character.';
    //     // }


    //     if (user.password) {
    //         if (!regexPatterns.password.test(user.password)) {
    //             errors.password = 'Invalid password: must be at least 8 characters long and include at least one letter, one number, and one special character.';
    //         }
    //     }
    //     setProfileFromError(errors);
    //     return Object.keys(errors).length === 0;
    // };

    const validateForm = () => {
        let errors = {};
        if (passwordValue && !regexPatterns.password.test(passwordValue)) {
            errors.password = 'Invalid password: At least one lowercase, one uppercase, one numeric, and minimum 8 characters';
        }
        setProfileFormError(errors);
        return Object.keys(errors).length === 0;
    };;

    const header = <div className="font-bold mb-3">Pick a password</div>;
    const footer = (
        <>
            <Divider />
            <p className="mt-2">Suggestions</p>
            <ul className="pl-2 ml-2 mt-0 line-height-3">
                <li>At least one lowercase</li>
                <li>At least one uppercase</li>
                <li>At least one numeric</li>
                <li>Minimum 8 characters</li>
            </ul>
        </>
    );
    return (
        <div>
            <Toast ref={toast} position="bottom-right"></Toast>
            <Grid container spacing={2}>
                <Grid item xs={12} md={12} lg={9} sx={{ gap: 1, flexGrow: 1, overflow: 'hidden auto' }}>
                    <Box className="card omega-forms">
                        <Box sx={{ minWidth: 0, flex: 1, padding: '1rem' }}>
                            <Grid container spacing={2}>
                                <Grid item xs={4}>
                                    <Typography level="title-sm" className='fs-2'>Full Name</Typography>
                                    <Typography level="body-xs" className='fs-3' htmlFor="full-name">Enter the full name for this user</Typography>
                                </Grid>
                                <Grid item xs={8}>
                                    <InputText
                                        id="firstName"
                                        value={user.firstName}
                                        onChange={handleInputChange}
                                        className="mr-2"
                                    />
                                </Grid>
                            </Grid>
                            <Grid container spacing={2}>
                                <Grid item xs={4}>
                                    <Typography level="title-sm" className='fs-2'>Email</Typography>
                                    <Typography level="body-xs" className='fs-3' htmlFor="email">Enter the email for this user</Typography>
                                </Grid>
                                <Grid item xs={8}>
                                    <InputText
                                        id="email"
                                        disabled
                                        value={user.email}
                                        onChange={handleInputChange}
                                        className="mr-2"
                                    />
                                </Grid>
                            </Grid>
                            <Grid container spacing={2}>
                                <Grid item xs={4}>
                                    <Typography level="title-sm" className='fs-2'>Designation</Typography>
                                    <Typography level="body-xs" className='fs-3' htmlFor="designation">Enter the designation for this user</Typography>
                                </Grid>
                                <Grid item xs={8}>
                                    <InputText
                                        id="designation"
                                        value={user.designation}
                                        onChange={handleInputChange}
                                        className="mr-2"
                                    />
                                </Grid>
                            </Grid>
                            <Grid container spacing={2}>
                                <Grid item xs={4}>
                                    <Typography level="title-sm" className='fs-2'>Password</Typography>
                                    <Typography level="body-xs" className='fs-3' htmlFor="password">Enter a new password for this user to update, else keep blank</Typography>
                                </Grid>
                                <Grid item xs={8}>
                                    {/* <InputText
                                        id="password"
                                        value={user.password}
                                        onChange={handleInputChange}
                                        className={profileFromError.password ? "mr-2 p-invalid" : "mr-2"}
                                    />
                                    {profileFromError.password && (
                                        <Typography level="title-sm" className="error-message fs-2">{profileFromError.password}</Typography>
                                    )} */}
                                    <Password
                                        id="password"
                                        className={profileFormError.password ? "mr-2 p-invalid" : "mr-2"}
                                        value={passwordValue}
                                        onChange={(e) => {
                                            setPasswordValue(e.target.value);
                                        }}
                                        header={header}
                                        footer={footer}
                                        toggleMask
                                    />
                                    {profileFormError.password && (
                                        <Typography level="title-sm" className="error-message fs-2">{profileFormError.password}</Typography>
                                    )}
                                </Grid>

                            </Grid>

                            <Grid container spacing={2}>
                                <Grid item xs={4}>
                                    <Typography level="title-sm" className='fs-2'>Role</Typography>
                                    <Typography level="body-xs" className='fs-3' htmlFor="role">Role assigned to this user</Typography>
                                </Grid>
                                <Grid item xs={8}>
                                    <InputText
                                        disabled
                                        id="authorities"
                                        value={userRoleName(user)}
                                        className="mr-2"
                                    />
                                </Grid>
                            </Grid>
                        </Box>
                        <Box sx={{ minWidth: 0, display: 'flex', padding: '1rem', justifyContent: 'end' }} gap={2} className="form-footer">
                            <Button type="button" className="button-style-1" label="Update" size="small" onClick={handleFormSubmit}></Button>
                        </Box>
                    </Box>
                </Grid>
            </Grid>
        </div>
    );
}
